import jq from 'jquery';
import _ from 'ext:lodash';
import urlMapper from 'lib/url-mapper';

export default {
	getOffer(link){
		if(link) {
			//remove the .html from the link
			if(link.indexOf('.html') > -1) {
				link = link.substring(0, link.indexOf('.html'));
			}

			link = urlMapper.mapUrl(link);

			// create link to header
			link = link + '/_jcr_content/par.html';

			return new Promise((resolve, reject)=> {
				jq.get(link)
					.then((data)=> {
						//SUCCESS
						resolve(data);
					}, (xhr)=> {
						reject(xhr.status);
					});
			});
		}else{
			return null;
		}
	}
};
